import { render } from "./index.vue?vue&type=template&id=3a0a35d8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3a0a35d8&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0a35d8"]])

export default __exports__